
import Vue from 'vue';
import DashboardPlugin from './plugins/dashboard-plugin';
import utilsService from '@/api/utilsService';
import App from './App.vue';
import 'sweetalert2/dist/sweetalert2.min.css';
import 'vue-toastification/dist/index.css';
import Toast from 'vue-toastification';
import Swal from 'sweetalert2';
import router from './routes/router';
import translator from '@/util/language.js'; 

window.Swal = Swal;
Vue.use(DashboardPlugin);
Vue.use(Toast);
Vue.prototype.$t = translator.t.bind(translator);
Vue.prototype.$setLanguage = translator.setLanguage.bind(translator);
Vue.prototype.$getLanguage = translator.getLanguage.bind(translator);
Vue.prototype.$utilsService = utilsService;
Vue.prototype.$globalMethods = {};

new Vue({
  el: '#app',
  render: h => h(App),
  router
});
